module.exports = __webpack_public_path__ + "img/jp_lemon.56820284.jpg";